import {Component, Inject, OnInit}                                                  from '@angular/core';
import {UntypedFormGroup, FormBuilder, FormControl, UntypedFormControl, Validators} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog}                                   from '@angular/material/dialog';
import {MatSnackBar}                                                                from '@angular/material/snack-bar';
import {ApiService}                                                                 from '@src/app/shared/services/api.service';
import moment                                                                       from 'moment';
import {DialogComponent}                                                            from '@src/app/shared/components/dialog/dialog.component';

@Component({
    standalone: false,
    selector: 'app-delete-price-tier-modal',
    templateUrl: './delete-price-tier-modal.component.html',
})
export class DeletePriceTierModalComponent implements OnInit
{
    @Inject(MAT_DIALOG_DATA) public data: { priceTier: any, type: string, effectiveFrom?: Date }
    public priceTierForm: UntypedFormGroup;
    public currentDate: Date = new Date();

    constructor(
        private apiService: ApiService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<DeletePriceTierModalComponent>,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
    )
    {
    }

    ngOnInit(): void
    {
        if (this.data?.effectiveFrom) {
            this.currentDate = this.data.effectiveFrom;
        }
        this.initForm();
    }

    private initForm(): void
    {
        this.priceTierForm = new UntypedFormGroup({
            id: new UntypedFormControl(
                this.data?.priceTier ? this.data?.priceTier?.id : ''
            ),
            effective_to: new FormControl<Date>(null, Validators.required),
            tier: new UntypedFormControl(
                {value: this.data?.priceTier?.tier ?? 0, disabled: true}
            )
        });
    }

    public removeTier(): Promise<void>
    {
        if (this.priceTierForm.valid) {
            return new Promise<void>((resolve) => {
                const confirmDialogRef = this.dialog.open(DialogComponent, {
                    data: {
                        title: 'Delete Price Tier',
                        message: `Are you sure want to delete this price tier?`,
                        type: 'danger',
                        confirmButtonLabel: 'Delete'
                    }
                });

                confirmDialogRef.afterClosed().subscribe(async (confirm) => {
                    if (confirm) {
                        this.priceTierForm.patchValue({
                            effective_to: moment(this.priceTierForm.get('effective_to')?.value).format('YYYY-MM-DD HH:mm:ss'),
                        });

                        this.apiService.post(`products/prices/${this.data?.priceTier?.id}/delete`, this.priceTierForm.getRawValue())
                            .subscribe({
                                next: () => {
                                    this.snackBar.open('Price tier deleted successfully', 'Close', { duration: 3000, panelClass: ['success-snackbar'] });
                                    this.dialogRef.close(true);

                                    resolve();
                                },
                                error: error => {
                                    this.apiService.handleError(error);
                                    this.snackBar.open('Failed to delete price tier', 'Close', { duration: 3000, panelClass: ['error-snackbar'] });

                                    resolve();
                                }
                            });
                    } else {
                        resolve();
                    }
                });
            });
        } else {
            this.snackBar.open('Please enter an Effective To date', 'Close', {
                duration: 3000,
                panelClass: ['error-snackbar']
            });
        }
        return Promise.resolve();
    }
}
